/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.DynamicPortalRpc
 */

export const getDynamicPortalObjectsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.DynamicPortalRpc',
  rpcName: 'getDynamicPortalObjects',
  auth: 'external',
  fingerprint: 'I2NO9VckHpujfk2bo4G_2ddmQEYkesB7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCrmObjectContactsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.DynamicPortalRpc',
  rpcName: 'getCrmObjectContacts',
  auth: 'external',
  fingerprint: '8LOafgiONYPbh0qaWV1MPddmQEYkesB7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};